import React, { useMemo, useState } from "react";

import { mdiProgressWrench } from "@mdi/js";
import Icon from "@mdi/react";
import classNames from "classnames";
import { useTranslation } from "react-i18next";
import { NavLink } from "react-router-dom";

import useInProgressEncodingList from "../../hooks/useInProgressEncodingList";
import useOutsideClick from "../../hooks/useOutsideClick";
import DataTable from "../dataTable/DataTable";
import {
  encodingProgressColumns,
  getEncodingProgressHref,
} from "./tableParams/encodingProgressColumns";

import type { JSX } from "react";

import type { EncodingJobTableItem } from "../../hooks/useInProgressEncodingList";

function NavbarAdminEncodingProgress(): JSX.Element {
  const [isOpen, setIsOpen] = useState(false);
  const ref = useOutsideClick(() => {
    if (isOpen) {
      setIsOpen(false);
    }
  });

  const iconClassName = classNames("hover:opacity-100", {
    "opacity-50": !isOpen,
  });

  const { t } = useTranslation("navbar");
  const { isLoading, itemList, totalItems } = useInProgressEncodingList();
  const columnList = useMemo(() => encodingProgressColumns({ t }), [t]);

  const getRowHref = (encoding: EncodingJobTableItem): string | undefined =>
    getEncodingProgressHref(encoding.mediaUuid);

  return (
    <div ref={ref} className="relative">
      <div
        className="text-primary-foreground relative cursor-pointer"
        data-testid="NavbarAdminEncodingProgress-toggle"
        onClick={(): void => setIsOpen(!isOpen)}
      >
        <Icon className={iconClassName} path={mdiProgressWrench} size={1} />
        {totalItems > 0 && (
          <div className="bg-destructive text-primary-foreground absolute bottom-3.75 left-3.75 flex size-4.5 items-center justify-center rounded-full text-[11px] opacity-100">
            {totalItems < 10 ? totalItems : "9+"}
          </div>
        )}
      </div>
      {isOpen ? (
        <div className="border-border bg-card absolute top-10 right-0 z-1000 flex w-150 flex-col gap-[0.78125rem] rounded-[0.3125rem] border p-[0.78125rem]">
          <div className="flex justify-between">
            <div className="flex items-center gap-[0.78125rem]">
              <div className="border-border rounded-lg border p-0.5">
                <Icon path={mdiProgressWrench} size={1} />
              </div>
              <div className="text-lg font-semibold">
                {t("activeEncodings")}
              </div>
            </div>
            <NavLink
              className="hover:text-primary flex items-end text-[0.703125rem]"
              onClick={() => setIsOpen(!isOpen)}
              to="/encodings"
            >
              {t("seeAllEncodings")}
            </NavLink>
          </div>
          {/* Fenêtre présente sur toutes les pages : elle n'écrit rien dans l'URL. */}
          <DataTable
            compactPagination
            columns={columnList}
            data={itemList}
            getRowHref={getRowHref}
            isLoading={isLoading}
            urlSync={false}
          />
        </div>
      ) : null}
    </div>
  );
}

export default NavbarAdminEncodingProgress;
